import { Box } from '@mui/material';
import MessageGroup from 'components/@home/@messages/ChatPanel/MessagesList/MessageGroup';
import { formatRequiresDigitalSignature } from 'components/@home/@documents/SentDocuments/edit-steps/editTemplateFlow';
import { getFileName } from 'components/@home/drawers/HrBotDrawer/pdf-utils';
import IphonePreview from 'components/common/IphonePreview';
import { array, bool, object, string } from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { HR_BOT_APP_ID } from 'services/constants';

/**
 * Chat-style message + PDF attachment preview (same layout as StepMessage).
 */
const SendMessagePhonePreview = ({
  message,
  signatureCardTitle = '',
  isRoutedSend = false,
  files = [],
  userItems,
  format,
}) => {
  const app = useSelector(state => state.apps.apps?.[HR_BOT_APP_ID]);
  const sendBy = format?.sendBy || 'code';
  const file = useMemo(
    () => files?.find(f => !f.error && f.employee?.[sendBy]) || { file: {} },
    [files, sendBy],
  );
  const name = getFileName({ ...file, ...userItems }, format);
  const { size } = file.file || {};

  const hasSignatureFlow = formatRequiresDigitalSignature(format);
  const previewTitle = isRoutedSend
    ? name
    : (signatureCardTitle || '').trim() || (format?.name ? `${format.name}.pdf` : name);

  return (
    <IphonePreview>
      <Box
        sx={{
          zoom: 0.7,
          flexDirection: 'column',
          p: 1.25,
          flexGrow: 1,
          bgcolor: 'secondary.ultraLight',
          display: 'flex',
          justifyContent: 'flex-end',
          fontSize: 14,
          pointerEvents: 'none',
        }}
      >
        <MessageGroup
          msgRef={() => {}}
          message={{
            text: message,
            title: previewTitle,
            digitalSignature: hasSignatureFlow,
            isMandatory: hasSignatureFlow,
            attachments: [
              {
                name,
                httpLink: name,
                mimeType: 'application/pdf',
                type: 'doc',
                size,
              },
            ],
            employee: {
              avatar: app?.avatar,
              firstName: app?.name,
            },
          }}
        />
      </Box>
    </IphonePreview>
  );
};

SendMessagePhonePreview.propTypes = {
  message: string.isRequired,
  signatureCardTitle: string,
  isRoutedSend: bool,
  files: array,
  userItems: object.isRequired,
  format: object.isRequired,
};

export default SendMessagePhonePreview;
